import { defineAppConfig } from "#imports";
export default defineAppConfig({
  ui: {
    button: {
      compoundVariants: [
        {
          color: "primary",
          variant: "solid",
          class: "text-white",
        },
      ],
    },
    tabs: {
      compoundVariants: [
        {
          color: "primary",
          variant: "pill",
          class: {
            trigger:
              "data-[state=active]:text-white data-[state=inactive]:text-white/80 hover:data-[state=inactive]:text-white",
          },
        },
      ],
    },
  },
});
